import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const Pagination = ({ currentPage, totalCount, onPageChange, pageSize = 20 }) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  if (totalCount === 0) return null;

  return (
    <Box
      sx={{
        padding: '8px 0',
        background: 'transparent',
      }}
    >
      {totalPages > 1 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            paddingBottom: 1
          }}
        >
          <IconButton
            onClick={() => onPageChange(currentPage - 1, pageSize)}
            disabled={currentPage === 1}
            sx={{
              color: 'var(--secondary-color)',
              borderRadius: 2,
              '&:disabled': { opacity: 0.3 },
              '&:hover': { color: 'var(--primary-color)' },
              '&:active': { color: 'var(--primary-color)' },
            }}
          >
            <ChevronLeft />
          </IconButton>

          <Typography sx={{ color: 'var(--secondary-color)' }}>
            {currentPage}/{totalPages}
          </Typography>

          <IconButton
            onClick={() => onPageChange(currentPage + 1, pageSize)}
            disabled={currentPage === totalPages}
            sx={{
              color: 'var(--secondary-color)',
              borderRadius: 2,
              '&:disabled': { opacity: 0.3 },
              '&:hover': { color: 'var(--primary-color)' },
              '&:active': { color: 'var(--primary-color)' },
            }}
          >
            <ChevronRight />
          </IconButton>
        </Box>
      )}
      <Typography
        sx={{
          display: 'flex',
          justifyContent: 'center',
          color: 'var(--secondary-color)'
        }}
      >
        {totalPages > 1
          ? `当前页：${currentPage}，共 ${totalCount} 条数据，每页 ${pageSize} 条`
          : `共 ${totalCount} 条数据`}
      </Typography>
    </Box>
  );
};

export default Pagination;